import React from 'react'

export default function Icon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="12" cy="12" r="12" fill="#FF4C00" />
      <path
        d="M14.6844 15.28V18H13.2924V15.28H7.75644V14.224L12.7964 6.528H14.6844V13.984H16.2364V15.28H14.6844ZM13.2924 13.984V7.952L9.34044 13.984H13.2924Z"
        fill="white"
      />
    </svg>
  )
}
